<template>
  <div class="home">
    <loading
      :active.sync="loader.isLoading"
      :can-cancel="loader.canCancel"
      :is-full-page="loader.fullPage"
      :color="loader.color"
      :height="loader.height"
      :width="loader.width"
      :background-color="loader.backgroundColor"
      :loader="loader.loader">
      </loading>
    <StockAdjustmentList v-show="listView" @newAdjust="onClickNewFromList" @editAdjust="onClickEditFromList" :scroll="corY" ref="refreshList"/>
    <StockAdjustmentForm v-show="formView" :adjust="adjust"  @backClicked="onBackChild" />
  </div>
</template>

<script>
// @ is an alias to /src
import StockAdjustmentList from '@/components/stock/adjust/StockAdjustmentList.vue'
import StockAdjustmentForm from '@/components/stock/adjust/StockAdjustmentForm.vue'
import Loading from 'vue-loading-overlay'
import { mapState } from 'vuex'

export default {
  name: 'StockAdjust',
  components: {
    StockAdjustmentList,
    StockAdjustmentForm,
    Loading
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      adjust: {
        id: null,
        adjust_no: null,
        adjust_date: null,
        adjust_notes: null,
        branch_no: null,
        branch: null,
        user_id: null,
        user: null,
        ref_no: null,
        approve_by: null,
        approve_date: null,
        lock: false,
        status: null,
        type: null,
        onhands: [{
          id: null,
          product_no: null,
          product: null,
          qty: null,
          price: '0',
          on_hand_date: null,
          notes: null,
          warehouse_no: null,
          branch_no: null,
          uom_id: null,
          adjust_no: null,
          serial_number: null,
          canBarcode: false,
          uomList: [{
            id: null,
            name: null,
            category_id: null,
            type_id: null,
            ratio: null,
            active: null,
            cost: '0',
            price: '0'
          }]
        }]
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.adjust = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.adjust = {
        id: null,
        adjust_no: null,
        adjust_date: new Date().toISOString(),
        adjust_notes: null,
        branch_no: this.authUser.branch_no,
        branch: null,
        user_id: null,
        user: null,
        ref_no: null,
        approve_by: null,
        approve_date: null,
        lock: false,
        status: null,
        type: 'adjust',
        onhands: [{
          product_no: null,
          product: null,
          qty: null,
          price: '0',
          on_hand_date: null,
          notes: null,
          warehouse_no: null,
          branch_no: null,
          uom_id: null,
          adjust_no: null,
          serial_number: null,
          canBarcode: false,
          uomList: [{
            id: null,
            name: null,
            category_id: null,
            type_id: null,
            ratio: null,
            active: null,
            cost: '0',
            price: '0'
          }]
        }]
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.adjust = {
        id: null,
        adjust_no: null,
        adjust_date: null,
        adjust_notes: null,
        branch_no: null,
        branch: null,
        user_id: null,
        user: null,
        ref_no: null,
        approve_by: null,
        approve_date: null,
        lock: false,
        status: null,
        type: null,
        onhands: [{
          id: null,
          product_no: null,
          product: null,
          qty: null,
          price: '0',
          on_hand_date: null,
          notes: null,
          warehouse_no: null,
          branch_no: null,
          uom_id: null,
          adjust_no: null,
          serial_number: null,
          canBarcode: false,
          uomList: [{
            id: null,
            name: null,
            category_id: null,
            type_id: null,
            ratio: null,
            active: null,
            cost: '0',
            price: '0'
          }]
        }]
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser
    })
  },
  mounted () {
    this.$store.dispatch('getBranchList')
    this.$store.dispatch('getProductList')
    this.$store.dispatch('getWarehouseList')
  }
}
</script>
